module.exports = __webpack_public_path__ + "static/media/16_aoun_a.513b4b62.ogg";